import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { AdminRoute } from '../routes';
import AssignedProjects from './Assigned';
import UnassignedProjects from './Unassigned';
import CompletedProjects from './Completed';
import ScheduledProjects from './ScheduledProjects';
import CreateProject from './CreateProject';
import ProjectView from './ProjectView';

const ProjectsPage = ({ match: { path } }) => (
  <Switch>
    <Route path={`${path}/scheduled`} component={ScheduledProjects} />
    <Route path={`${path}/unassigned`} component={UnassignedProjects} />
    <Route path={`${path}/assigned`} component={AssignedProjects} />
    <Route path={`${path}/completed`} component={CompletedProjects} />
    <AdminRoute path={`${path}/create`} component={CreateProject} />
    <Route path={`${path}/:id`} component={ProjectView} />
  </Switch>
);

export default ProjectsPage;



// WEBPACK FOOTER //
// ./src/components/projects/ProjectsPage.js